import styled from 'styled-components';

import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import LayoutCollectionView from '../LayoutCollectionView/LayoutCollectionView';
import { 
  removeOfferById,
  saveOffer
} from '../../../../lib/user';
import {
  OFFERS,
  GRID
} from '../../../../lib/constants';
import OfferCard from '../Offer/OfferCard';
import { StyledHtmlRenderer } from '../shared/StyledHtmlRenderer';

const PageBodyDiv = styled(StyledHtmlRenderer)`
  margin-bottom: ${p => p.theme.unit(3)};
`;

const SplashPageContent = (props) => {
  const {
    splashPageData = {},
    pageStateModifiers = {},
    userData,
    locale = 'en'
  } = props;

  const {
    name = '',
    splashContent = '',
  } = splashPageData;

  const favOffersIds = userData.offers && userData.offers.length ? 
    userData.offers.map(offer => offer.id) : []; 

  const pageBodyRender = (
    <PageBodyDiv dangerouslySetInnerHTML={{
      __html: splashContent,
    }} />
  );

  const offerCardGridRender = (
    <LayoutCollectionView
      favItemIds={favOffersIds}
      items={splashPageData.offers}
      Comp={OfferCard}
      itemType={OFFERS}
      viewType={GRID}
      pageStateModifiers={pageStateModifiers}
      saveItemHandler={saveOffer}
      removeItemHandler={removeOfferById}
      locale={locale}
      showDisplayName
    />
  );

  return (
    <MaxWidthLayout>
      {pageBodyRender}
      {offerCardGridRender}
    </MaxWidthLayout>
  );
};

export default SplashPageContent;
